var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFireSolid = function SvgFireSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.942 1.673a.75.75 0 0 0-1.184.32l-2.063 5.663L8.43 5.462a.75.75 0 0 0-1.118.083C5.282 8.205 4.25 10.882 4.25 13.5a8.25 8.25 0 1 0 16.5 0c0-5.574-4.762-10.125-6.808-11.827Z",
    fill: "currentcolor"
  })));
};
export default SvgFireSolid;